<template>
	<div>
    <el-row>
      <el-col :span="8">

        <el-button type="primary" @click="updateRole()">{{$t('mao_global.btn.confirmUpdate')}}</el-button>
        <el-button @click="resetCheck()">{{$t('mao_global.btn.reset')}}</el-button>
      </el-col>
    </el-row>


    <el-row class=''>

      <!-- <p class="gPTitle">{{$t('menuConfig.role.modelSelect')}}</p> -->

      <el-col :span="16">

        <el-tree
          class='gTopMg gSgLeftBtn'
          ref="tree"
          show-checkbox
          :data="resultData"
          :props="defaultProps"
          node-key="menuId"
          default-expand-all
          :expand-on-click-node="false">
        </el-tree>
      </el-col>
    </el-row>


    <el-form label-position="left" label-width="90px" style="width: 60%;margin-top: 10px;">
      <el-form-item>

      </el-form-item>
    </el-form>
	</div>

</template>

<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  import jq from 'jquery'
	export default{
    data(){
			return {
				// 提交的表单
				submitForm: {
          token: localStorage.getItem('user'),
          menuId: ""
        },
        planeMenuList: null,
        menuList: [],
        // 菜单列表
        resultData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        }
      }
		},
    mounted () {
    	var that = this
      that.fetchData()
		},
		methods:{
    	// 提交角色数据
      updateRole () {
    		var that = this

        // that.submitForm.subId = that.getCheckedKeys()
        that.submitForm.subId = that.getCheckedKeysTwo()

        console.log('返回的subId拼接字符串:')
        console.log(that.submitForm.subId)


        // return;

        axios.post(`${baseurl}/role/editRoleByRights.do`,{roleId: this.$route.params.id,subId: that.submitForm.subId}).then(res=>{
          if (res.data && res.data.status && res.data.status === 200) {
            that.$message(this.$t('menuConfig.role.updateSuccess'))
            that.$router.push({path: '/roleManager'})
          }
        })

      },
      getCheckedKeysTwo () {

        let resultSubIdString = ""


        // 获得所有菜单平铺的列表, 没有层级关系
        var copyPlaneMenuData = jq.extend(true,[],this.planeMenuList)

        // 获得选中打钩的所有菜单项menuId (这里是menuId)
        var checkKeysList = this.$refs.tree.getCheckedKeys();


        // 通过menuId关联出当前选择对象
        let getObjectByMenuId = (menuId) => {
          let currentObj = null

          // 获取到平铺列表的总长度
          let len = copyPlaneMenuData.length

          // 循环找出对象
          for (var i=0; i < len; i++) {
            // 平铺列表中的某个对象
            let o = copyPlaneMenuData[i]
            if (o.menuId === menuId) {
              currentObj = o
              break;
            }
          }

          return currentObj
        }

        // 根据菜单id关联出 subId
        let getSubIdByMenuId = (menuId) => {
          // 根据menuId查询出来的对象
          let cObject = getObjectByMenuId(menuId)
          // 如果能查询出该对象, 则证明一定存在subId, 或许存在 superId
          if (cObject) {
            resultSubIdString += cObject.subId + ","
            copyPlaneMenuData = copyPlaneMenuData.filter( child => {
              if (menuId !== child.menuId) {
                return child
              }
            })
            if (cObject.superId && cObject.superId !== "0") {
              // 过滤菜单,减少循环次数
              getSubIdByMenuId(cObject.superId)
            }
          }
        }

        // 遍历所有选中的节点(menuId)关联出所有父级的subId
        if (checkKeysList && checkKeysList.length > 0) {
          let leng = checkKeysList.length
          for (var i=0; i < leng; i++) {
            // 选中列表中, 其中一个 menuId
            let selectMenuId = checkKeysList[i]
            getSubIdByMenuId(selectMenuId)
          }
        }

        return resultSubIdString.substring(0,resultSubIdString.length-1)
      },
      // getCheckedKeys() {
      //
      //   var that = this
      //
      //
      //   // 获得所有菜单平铺的列表, 没有层级关系
      //   var copyPlaneMenuData = jq.extend(true,[],this.planeMenuList)
      //
      //
      //   // todo 代码需要重构优化
      //
      //   // 获取父级元素id
      //   var getParentId =  (id) => {
      //     var retData = null
      //     for (var i = 0; i < copyPlaneMenuData.length; i++) {
      //       var o = copyPlaneMenuData[i]
      //       if (o.menuId === id && o.superId !== "0") {
      //         retData = o.superId
      //         break;
      //       }
      //     }
      //     return retData
      //   }
      //
      //
      //
    	// 	var resultData = ""
      //
      //   // 获得选中打钩的菜单项
    	// 	var checkKeysList = this.$refs.tree.getCheckedKeys();
      //
      //
      //   // return;
    	// 	if (checkKeysList && checkKeysList.length > 0) {
    	// 		for (var i=0; i<checkKeysList.length; i++) {
      //       resultData += checkKeysList[i] + ","
      //
      //       var parentIId = getParentId(checkKeysList[i])
      //       console.log('父id')
      //       console.log(parentIId)
      //
      //       if (parentIId) {
      //         // 过滤菜单,减少循环次数
      //         copyPlaneMenuData = copyPlaneMenuData.filter( child => {
      //           if (parentIId !== child.menuId && child.menuId !== checkKeysList[i] ) {
      //             return child
      //           }
      //         })
      //
      //
      //         console.log(JSON.stringify(copyPlaneMenuData, null, 2))
      //         return;
      //
      //
      //         // 去重 / 添加父级节点
      //         if (resultData.indexOf(parentIId) === -1) {
      //           resultData += parentIId + ","
      //         }
      //       }
      //     }
      //
      //     resultData = resultData.substring(0,resultData.length-1)
      //   }
      //   return resultData
      // },
      resetCheck () {
        this.$refs.tree.setCheckedKeys([]);
      },
      // 获取初始化数据
      fetchData () {
        var that = this


        // 获取平面化的菜单列表
        var re = [];
        var toPlaneMenuList = (data) => {
          data.forEach((value)=>{
            var tmp = null
            if (value.children) {
              var tChildNode =  jq.extend(true,{},value)
              delete tChildNode.children
              re.push(tChildNode)
              tmp =  toPlaneMenuList(value.children)
            } else {
              tmp = value
            }
            if (tmp) re.push(tmp)
          })
        };



        // 获取树形菜单列表
        axios.post(`${baseurl}/menu/getAllMenu.do`,{token: localStorage.getItem('user')}).then(res=>{
          if (res.data && res.data.status && res.data.status === 200) {
            that.resultData = res.data.data
            toPlaneMenuList(that.resultData)

            that.planeMenuList = re;

            axios.post(`${baseurl}/role/selectMenuList.do`,{roleId: this.$route.params.id}).then(res=>{
              if (res.data && res.data.status && res.data.status === 200) {
                var checkArray = []

                let selectedMenuDataList = res.data.data

                // todo 代码需要重构优化

                // 过滤出没有父节点的菜单列表
                var noParentArray = jq.extend(true,[],this.planeMenuList)
                // noParentArray = noParentArray.filter(c=>{ if (!c.superId || c.superId !== "0" || c.superId === "") return c })
                noParentArray = noParentArray.filter(c=>{ if (c.menuStatus !== "1") return c })

                // console.log(JSON.stringify(noParentArray, null, 2))
                // 匹配是否存在 非父节点的菜单 (返回boolean)
                var onArray = (mid) => {
                  var flag = null
                  let size = noParentArray.length;
                  for(var i = 0; i < size; i++) {
                    if (noParentArray[i]['subId'] === mid) {
                      // console.log('匹配出来subId相同的对象')
                      // console.log(noParentArray[i])
                      flag = noParentArray[i]['menuId']
                      break;
                    } else {
                      // console.log('没有匹配到对象')
                    }
                  }
                  return flag
                }



                let selectLength = selectedMenuDataList.length
                for (var i=0; i< selectLength; i ++) {
                  let menuId = onArray(selectedMenuDataList[i]['subId'])
                  if (menuId) {
                    checkArray.push(menuId)
                  }
                }

                console.log(JSON.stringify(checkArray, null, 2))
                if (checkArray.length > 0) {
                  this.$refs.tree.setCheckedKeys(checkArray);
                }
              }
            })
          }
        })

      }
		}
	}
</script>



// WEBPACK FOOTER //
// role-update.vue?d0716ab6